export default __webpack_public_path__ + "static/media/Profile_Icon.a2c68683.svg";